import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import mantineTheme from '@/theme/mantine-theme';
import { UserProvider } from '@/contexts/user-context';
import BetaApp from '@/beta/beta-app';

// Old /beta/* links and bookmarks land on the same page at the root.
function StripBetaPrefix() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={(pathname.replace(/^\/beta/, '') || '/') + search + hash} replace />;
}

function App() {
  return (
    <MantineProvider theme={mantineTheme}>
      <Notifications position="top-right" />
      <UserProvider>
        <Router>
          <Routes>
            <Route path="/beta/*" element={<StripBetaPrefix />} />
            {/* Classic-site account pages, merged into /account. */}
            <Route path="/my-account" element={<Navigate to="/account" replace />} />
            <Route path="/settings" element={<Navigate to="/account" replace />} />
            <Route path="/*" element={<BetaApp />} />
          </Routes>
        </Router>
      </UserProvider>
    </MantineProvider>
  );
}

export default App;
